import { defineStore } from "pinia";
import { useCurrentUserStore } from "./CurrentUserStore";
import _ from "lodash";

export const useCountryStore = defineStore("countries", {
    state: () => ({
        list: [],
        fullList: [],
        take: 25,
        skip: 0,
        columns: [
            {
                table: "search_index_name",
                direction: "ASC",
                direction_pos: 0,
                sortkey: "value",

                key: "name.en",
                label: "name",
                setable: false,
                class: "is-2",
                display: true,
            },
            {
                table: "countries",
                direction: "ASC",
                direction_pos: 0,
                key: "alpha_2",
                label: "alpha_2",
                display: true,
            },
            {
                table: "countries",
                direction: "ASC",
                direction_pos: 0,
                key: "alpha_3",
                label: "alpha_3",
                display: true,
            },
        ],
        loaded: false,
        loadingMore: false,
        loading: false,
        allLoaded: false,
        addNew: false,
        infinity: {
            active: false,
        },
        workingOn: [],
        pagination: {
            currentPage: 1,
            totalPageCount: 1,
        },
        meta: {},
        isSaving: false,
        search: "",
    }),
    actions: {
        async get(id) {
            const currentUser = useCurrentUserStore();
            this.loading = true;
            return await this.axios
                .get(
                    "/api/v1/" + currentUser.internal_company + "/company/" + id
                )
                .then((response) => {
                    this.loading = false;
                    this.data = response.data.data;
                    return response.data.data;
                });
            this.loading = false;
        },
        isWorkingOn(id) {
            var index = this.workingOn.findIndex(id);
            if (index >= 0) {
                return true;
            } else {
                return false;
            }
        },
        findByName(name) {
            return this.list.find(
                (item) =>
                    item.name.en.toLowerCase() == name.toLowerCase() ||
                    (item.name.de != undefined &&
                        item.name.de.toLowerCase() == name.toLowerCase())
            );
        },
        findById(id) {
            return this.list.find((item) => item.id == id);
        },
        // Vex Actions
        async loadCountries() {
            const currentUser = useCurrentUserStore();
            await axios
                .get(
                    "/api/v1/countries/" +
                    currentUser.internal_company +
                    "/getList"
                )
                .then((response) => {
                    this.setList(response.data.data);
                    this.loaded = true;
                });
        },
        async loadAllCountries() {
            const currentUser = useCurrentUserStore();
            return await axios
                .get(
                    "/api/v1/countries/" +
                    currentUser.internal_company +
                    "/getList"
                )
                .then((response) => {
                    this.setFullList(response.data.data);
                    this.loaded = true;
                });
        },
        async load(page = 1) {
            const currentUser = useCurrentUserStore();
            this.setskip((page - 1) * this.take);
            this.isLoading(true);
            if (this.allLoaded == false) {
                await axios
                    .get(
                        "/api/v1/" +
                        currentUser.internal_company +
                        "/countries",
                        {
                            params: {
                                search: this.search,
                                take: this.take,
                                skip: this.skip,
                                table_columns: this.columns,
                            },
                        }
                    )
                    .then((response) => {
                        this.setList(response.data.data);
                        this.setpagination(
                            _.get(response, "data.meta.pagination", {
                                total: 0,
                                take: this.take,
                            })
                        );
                        this.isLoading(false);
                    });
            }
            this.isLoading(false);
        },
        async post_update(data) {
            const currentUser = useCurrentUserStore();
            this.isSaving = true;
            return axios
                .post(
                    "/api/v1/" +
                    currentUser.internal_company +
                    "/countries/" +
                    data.id,
                    data
                )
                .then((response) => {
                    this.isSaving = false;
                    this.update(response.data.data);
                });
        },
        async post_store(data) {
            const currentUser = useCurrentUserStore();
            this.isSaving = true;
            return axios
                .put(
                    "/api/v1/" + currentUser.internal_company + "/countries",
                    data
                )
                .then((response) => {
                    this.isSaving = false;
                    this.unshift(response.data.data);
                });
        },
        async delete(data) {
            if (data.data.url !== undefined && data.data.ids.length > 0) {
                for (var i = 0; i < data.data.ids.length; i++) {
                    var url = data.data.url + "/" + data.data.ids[i];
                    await axios
                        .delete(url)
                        .then((response) => {
                            this.deleteCountry(data.data.ids[i]);
                        })
                        .catch((error) => {
                            console.log(error.response.data.message);
                        });
                }
            }
        },
        async merge(data) {
            const currentUser = useCurrentUserStore();
            await axios
                .post(
                    "/api/v1/" +
                    currentUser.internal_company +
                    "/mergeCountries",
                    data
                )
                .then((response) => { });
        },

        // Vuex Mutations
        setSearch(value) {
            this.search = value.trim();
        },
        addCountry(load) {
            this.addNew = load;
        },
        setpagination(object) {
            this.meta = object;
            if (this.skip <= 0) {
                this.pagination.currentPage = 1;
            } else {
                this.pagination.currentPage = this.skip / this.take + 1;
            }
            this.pagination.totalPageCount = Math.ceil(
                this.meta.total / this.take
            );
            this.pagination.total = this.meta.total;
            this.pagination.pagesize = this.take;

            if (this.infinity.active == true && this.meta.total <= this.skip) {
                this.allLoaded = true;
            }
        },
        setskip(skip) {
            this.skip = skip;
        },
        clean() {
            this.list = [];
            this.loaded = false;
            this.pagination = {
                currentPage: 1,
                totalPageCount: 1,
                pagesize: 5,
            };
        },
        subLoading(mail) {
            var index = this.workingOn.findIndex((item) => (item = mail.id));
            if (index >= 0) {
                this.workingOn.splice(index, 1);
            } else {
                this.workingOn.push(mail.id);
            }
        },
        update(element) {
            var index = this.list.findIndex((item) => item.id == element.id);
            this.list[index] = element;
        },
        unshift(element) {
            this.list.unshift(element);
        },
        setList(list) {
            if (list == undefined || list.length <= 0) {
                this.allLoaded = true;
            }
            if (this.infinity.active == true) {
                this.list.push(...list);
            } else {
                this.list = list;
            }
        },
        setFullList(fullList) {
            fullList.sort(function (a, b) {
                if (a.name.en < b.name.en) return -1;
                if (a.name.en > b.name.en) return 1;
                return 0;
            });
            this.fullList = fullList;
        },
        setSteps(list) {
            if (list == undefined || list.length <= 0) {
                this.allLoaded = true;
            }
            this.steps.push(...list);
        },
        increasePage() {
            this.loadingMore = true;
            this.page++;
        },
        isLoading(status) {
            this.loadingMore = status;
            this.loading = status;
        },
        deleteCountry(id) {
            var index = this.list.findIndex((item) => item.id == id);
            if (index >= 0) {
                this.list.splice(index, 1);
            }
        },
        updateColumn(column) {
            var index = this.columns.findIndex(
                (item) => item.key == column.key
            );
            for (let i in this.columns) {
                this.columns[i].direction_pos += 1;
            }
            if (index > -1) {
                column.direction_pos = 0;
                this.columns[index] = column;
            }
        },
    },
});
